import React from 'react';
export function LegalDisclaimer() {
  return <section className="py-12 px-4 bg-white" data-id="element-166">
      <div className="max-w-4xl mx-auto" data-id="element-167">
        <p className="text-center text-sm text-[#8A7F7A] leading-relaxed" data-id="element-168">
          Este producto tiene fines educativos e informativos. No sustituye la
          evaluación, el diagnóstico ni el tratamiento de un profesional de la
          salud. Si presentas síntomas intensos, recurrentes o tienes dudas
          sobre tu diagnóstico, consulta con un médico o ginecólogo.
        </p>
      </div>
    </section>;
}